/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	/**
	 * @title BackInStockHelper.js: Sub-module
	 * @description This JS file contains functions related to the back in stock
	 *              functionalities
	 * 
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
		var BackInStockHelper = {
			init: function init() {},
	
			saveOOSNotificationRequest: function saveOOSNotificationRequest() {
				$("#notify-me-btn").attr("disabled", true);
				var catentryId = $('#catEntryId').val();
				COSTCO.util.ajax({
					type: 'GET',
					url: 'AjaxManageBackInStockSubscriptionCmd?action=subscribe&catentryId=' + catentryId + "&langId=" + wcs.langId + "&catalogId=" + wcs.catalogId + "&storeId=" + wcs.storeId,
					done: function done(data) {
						var jsonData = JSON.parse(data);
						if (jsonData.hasOwnProperty('success') && jsonData.success) {
							COSTCO.Product.showSuccessMessage(messages.PDETAIL_NOTIFY_ME_SUCCESS_MSG);
							$('.user-email span:nth-child(2) a').hide();
							$('.notify-me-btn-area').html('');
							$('.notify-me-btn-area').html(COSTCO.util.tmpl('tmpl_cancel_oos_notificaction', {}));
							if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
								$('.oos-notify-me-v2 .success-notification').html($('.notify-me-btn-area p').html()).removeClass('hide');
							} else {
								$('.oos-notify-me .text-area').html($('.notify-me-btn-area p').html());
							}
							$('.notify-me-btn-area p').remove();
						}
					},
					timeout: wcs.ajaxTimeout,
					fail: function fail(x, t, m) {
						if (t === 'timeout') {
							console.error('Error AJAX timeout.');
						} else {
							console.error('Unexpected AJAX error.');
						}
					}
				});
			},
			cancelOOSNotificationRequest: function cancelOOSNotificationRequest(e, userSubId) {
				$("#cancel-notification-btn").attr("disabled", true);
				var catentryId = $('#catEntryId').val();
				COSTCO.util.ajax({
					type: 'GET',
					url: 'AjaxManageBackInStockSubscriptionCmd?action=unsubscribe&catentryId=' + catentryId + "&langId=" + wcs.langId + "&catalogId=" + wcs.catalogId + "&storeId=" + wcs.storeId,
					done: function done(data) {
						var jsonData = JSON.parse(data);
						if (jsonData.hasOwnProperty('success') && jsonData.success) {
							COSTCO.Product.showSuccessMessage(messages.PDETAIL_NOTIFY_ME_SUCCESS_MSG);
							$('.user-email span:nth-child(2) a').show();
							$('.notify-me-btn-area').html('');
							$('.notify-me-btn-area').append(COSTCO.util.tmpl('tmpl_oos_notify_btn', {}));
							$('.oos-notify-me .text-area').html($('.notify-me-btn-area p').html());
							$('.notify-me-btn-area p').remove();
							if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
								$('.oos-notify-me-v2 .success-notification').addClass('hide').empty();
							}
						}
					},
					timeout: wcs.ajaxTimeout,
					fail: function fail(x, t, m) {
						if (t === 'timeout') {
							console.error('Error AJAX timeout.');
						} else {
							console.error('Unexpected AJAX error.');
						}
					}
				});
			}
		};
		if (typeof window.COSTCO == 'undefined') {
			window.COSTCO = new Object();
		}
	
		if (typeof window.COSTCO.Global == 'undefined') {
			document.addEventListener("CostcoGlobalLoaded", BackInStockHelper.init, false);
		} else {
			BackInStockHelper.init();
		}
	
		window.COSTCO.BackInStockHelper = BackInStockHelper;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// backinstockhelper.module.min.js